export default {
    name: 'productDetailsStockPage',
    before: [],
    after: [],
    setup: (app) => {
        const pageName = 'productDetailsStock';
        const pageRoute = app.routes.getItem(pageName);
        if (pageRoute) {
            const pageRouteProps = pageRoute.props;
            pageRoute.props = (state) => ({
                ...pageRouteProps(state),
                permissions: {
                    canAddStockLocation: true,
                    canInternalStockTransfer: true,
                    canCycleCount: true,
                    canAdjust: true,
                    canAddStockReservation: true,
                    canPrint: true,
                    withEditRestockSettings: true,
                },
            });

            app.routes.changeItem(pageName, pageRoute);
        }
    },
};
